<template>
  <wt-box :class="$style['pt-sub-title-tab']" :style="'background-color:' + bgColor" direction="row">
     <div class="active-style" :class="{'disableAnimate':disableAnimate}" ref="active">
            <!-- 高亮插槽，可放置其它高亮效果，默认为底部线条的形式 -->
            <slot>
                <div class="active-line"></div>
            </slot>
        </div>
        <wt-box ref="tabWarp" class="tab-warp" v-for="(item,index) in data" :key="index">
            <wt-box class="tab" ref="tabs" :class="{'tab-active':currentIndex ===index}" @click.native="onSelect(index)">{{item.label}}</wt-box>
            <span v-if="index!=data.length-1"> . </span>
        </wt-box>
    </wt-box>
</template>

<script>
// 组件class前缀
import _ from 'utils/typeof.js'
const prefixCls = 'pt-sub-title-tab'

export default {
  name: 'pt-sub-title-tab',
  props: {
    // 背景色
    bgColor: {
      type: String,
      default: '#F9F9F9'
    },
    value: String,
    data: {
      type: Array,
      required: true
    },
    // 是否根据router自动匹配高亮tab
    router: {
      type: Boolean,
      default: false
    },
    // 指示条是否使用过度
    transition: {
      type: Boolean,
      default: true
    }
  },
  components: {
    // wtBox
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },

  data () {
    return {
      disableAnimate: true,
      currentIndex: 0
    }
  },
  watch: {
    '$route' () {
      this.currentIndex = this.matchIndex()
    },
    value () {
      this.currentIndex = this.matchIndex()
    },
    currentIndex: {
      handler () {
        let val = this.data[this.currentIndex]
        if (_.isObject(val)) {
          if (val.to) {
            this.$router.replace(val.to)
          }
          val = val.value
        }
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onSelect (val) {
      this.currentIndex = val
      let selectVal = this.data[val]
      if (_.isObject(selectVal)) {
        selectVal = selectVal.value
      }
      this.$emit('input', selectVal)
    },
    // 根据路由匹配当前高亮的tab的index
    matchIndexByRouter () {
      let paths = this.$route.fullPath.split('/').filter(item => !!item)
      let index
      for (let i = 0; i < paths.length; i++) {
        const item = paths[i]
        index = this.data.findIndex(atem => {
          return _.isObject(atem) ? atem.to === item : atem === item
        })
        if (index > -1) {
          break
        }
      }
      return index
    },
    // 根据value or 路由来得到当前高亮tab的在传入参数data中的index，即currentIndex
    matchIndex () {
      if (this.router) {
        return this.matchIndexByRouter()
      } else if (this.value) {
        return this.data.findIndex(item => _.isObject(item) ? item.value === this.value : item === this.value)
      } else {
        return 0
      }
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.transition) {
        this.disableAnimate = false
      }
    }, 200)
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
@import '~less/var.less';
.pt-sub-title-tab{
    width:min-content;
    height:2.5em;
    position: relative;
    background: #F9F9F9;
    justify-content: flex-start!important;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    :global
    .tab-warp{
      display: flex;
      flex-direction: row!important;
      span{
        margin:0 10px;
        font-size: 30px;
      }
      .tab-active{
            color:#edbe81;
            display: contents;
            border-bottom:2px solid red;
        }
    }
    :global
    .wt-tab{
        padding:0 1em;
        color:@themeColor;

    }
    .active-style{
        position: absolute;
        bottom:0;
        top:0;
        left:0;
        transition:all 0.3s;
        will-change: width transform;
        &.disableAnimate{
            transition:none!important;
        }
        .active-line{
            position:absolute;
            bottom:0;
            display:block;
            width:100%;
            border-bottom:0.2em solid @themeColor;
        }
    }
}
</style>
